import { render, staticRenderFns } from "./float.vue?vue&type=template&id=6b67459f"
import script from "./float.vue?vue&type=script&lang=js"
export * from "./float.vue?vue&type=script&lang=js"
import style0 from "./float.vue?vue&type=style&index=0&id=6b67459f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports